import styled from 'styled-components/macro';
import images from '~/constants/images';

export const LocalColumn = styled.div`
  width: 50%;
  min-height: 100%;
  position: relative;
  background-color: ${({ theme, isLocal }) =>
    isLocal ? theme.light : theme.dark4};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    width: 100%;
  }
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-size: 700px;
  background-position: ${({ isLocal }) =>
      isLocal ? '-239px' : 'calc(50% + 239px)'}
    center;
  filter: grayscale(100%);
  z-index: 0;
  opacity: 0.1;
`;

export const TeamHeader = styled.div`
  position: relative;
  width: 100%;
  max-height: 74px;
  display: flex;
  padding: 0 50px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: ${({ isLocal }) => (isLocal ? 'row' : 'row-reverse')};
  font-size: ${({ theme }) => theme.title}px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  color: ${({ theme, isLocal }) => (isLocal ? theme.dark : theme.white)};
  flex: 1;
  background-color: ${({ theme, isLocal }) =>
    isLocal ? 'rgba(0, 0, 0, 0.1)' : theme.dark5};
  z-index: 1;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    padding: 0px 20px;
  }
  img {
    height: ${({ theme }) => theme.shieldBig}px;
    margin: ${({ isLocal }) => (isLocal ? '0 0 0 5px' : '0 5px 0 0')};
  }
`;

export const TeamSquad = styled.div`
  display: flex;
  flex-direction: ${({ isLocal }) => (isLocal ? 'row' : 'row-reverse')};
  z-index: 1;
  flex-grow: 1;
  padding: 0px 50px;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    padding: 0px 20px;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    flex-direction: column;
    min-height: 57vh;
  }
`;

export const SquadColumn = styled.div`
  width: ${props => (props.width ? props.width : '100%')};
  padding: 30px 0px;
  display: flex;
  ${({ isCourt }) =>
    isCourt
      ? 'flex-direction:row;justify-content:center;'
      : 'flex-direction:column;'}

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    flex-direction:column;
    height:auto;
    padding:${({ isCourt }) => (isCourt ? ' 0 3%' : '0')};
    justify-content:center;
    align-items:center;
  }
`;

export const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TeamSubheaderColumn = styled.div`
  width: 100%;
  padding: 0 10px 0;
  display: flex;
  ${({ row }) =>
    row === 'single'
      ? 'justify-content:center;align-items:center;'
      : 'flex-direction:column;justify-content:space-between;'}
  text-align: center;
  h3 {
    margin-top: 5px;
    color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
    text-transform: uppercase;
  }
  p {
    color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
    margin-bottom: 10px;
    font-size: ${({ theme }) => theme.paragraphBig}px;
    span {
      display: block;
      font-size: ${({ theme }) => theme.paragraph}px;
      margin-bottom: 5px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    justify-content: center;
    align-items: center;

    h3 {
      padding: 5px 15px;
      font-size: ${({ theme }) => theme.paragraph}px;
      border-bottom: 2px solid
        ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
      margin-bottom: 20px;
    }
    p {
      text-align: center;
      font-size: ${({ theme }) => theme.paragraphBig}px;
      span {
        text-transform: uppercase;
      }
    }
  }
`;

export const Court = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 370px;
  max-width: 100%;
  height: 580px;
  background-image: url(${images.court});
  background-repeat: no-repeat;
  background-position: center;
  padding: 20px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    padding: 3%;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  max-width: 370px;
`;

export const Player = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: ${({ theme, hovered }) =>
    hovered ? theme.coral : theme.white};
  background-image: url(${({ image }) => image || images.playerPlaceholder});
  background-position: center;
  background-size: contain;
  transition: background-color 0.2s;
`;

export const ShirtNumber = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-top: 45px;
  margin-left: 20px;
  background-color: ${({ isLocal, theme }) =>
    isLocal ? theme.white : theme.dark};
  color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
  line-height: 30px;
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme }) => theme.primaryFontBold};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
`;
